<script lang="ts">
	import '$lib/css/style.css';
	import { onMount } from 'svelte';

	let info: any = null;

	onMount(async () => {
		try {
			const res = await fetch('https://onlyyoubalitours.magotech.id/api/v1/info');
			const data = await res.json();
			info = data.data; // Sesuaikan dengan struktur API yang benar
		} catch (error) {
			console.error('Error fetching info:', error);
		}
	});
</script>

<svelte:head>
	{#if info}
		<link rel="icon" href={`https://onlyyoubalitours.magotech.id/storage/${info.icon}`} />
	{/if}
</svelte:head>

<div class="app">
	<main>
		<slot />
	</main>
</div>
